module.exports = __webpack_public_path__ + "static/media/pending.14bcaa05.svg";